import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/features/array/includes";
import "core-js/features/string/starts-with";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import getStore from "./store";
import rootReducer from "./reducers/rootReducer";
import routes from "./routes/routes";
import keyupHandler from "./utils/keyupHandler";
import Redirect from "./utils/Redirect";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import GoogleTracking from "./services/GoogleTracking";
import appConfig from "utils/appConfig";

import "./app.scss";

import "./images/favicon.ico";
import "./images/favicon-16x16.png";
import "./images/favicon-32x32.png";
import "./images/favicon-96x96.png";
import "./images/favicon-160x160.png";
import "./images/favicon-192x192.png";

GoogleTracking.registerEvent({ event: "Initial Load" });

const store = getStore(rootReducer);
const history = syncHistoryWithStore(browserHistory, store);

//if redirectTo httpParam exists, set up redirect cookie for after login
Redirect.readRedirectToParamandSetRedirectCookie(location.search);

if (appConfig().axeEnabled) {
    const axe = require("react-axe") as ( // eslint-disable-line
        react: typeof React,
        reactDOM: typeof ReactDOM,
        timeout: number,
        config?: any, // eslint-disable-line @typescript-eslint/no-explicit-any
        options?: any // eslint-disable-line @typescript-eslint/no-explicit-any
    ) => void;

    axe(React, ReactDOM, 3000, {
        rules: [{
            id: "frame-title",
            enabled: false
        }, {
            id: "page-has-heading-one", // this is alerting even when an h1 exists
            enabled: false
        }]
    }, {
        exclude: [
            [ ".__PrivateStripeElement" ],
            [ "iframe[name='__privateStripeFrame5']" ],
            [ "iframe[name='__privateStripeFrame6']" ],
            [ "iframe[name='__privateStripeFrame7']" ],
            [ "iframe.xcomponent-visible" ], // paypal button iframe
            [ "#full-price" ], // counter-offers color contrast
            [ ".dropdownList" ], // dropdownMenu form element
            [ "#react-autowhatever-1" ] // react-select library, can't be modified
        ]
    });
}

ReactDOM.render(
    <Provider store={ store }>
        { routes(history) }
    </Provider>,
    document.getElementById("content")
);

// [LC] 7/1/2016 listen for height change in iframe mode
if (window.parent !== window && !location.search.includes("closeable=false")) {
    document.addEventListener("keyup", keyupHandler);
}

export default React;
